import {
  DeviceEventEmitter,
  Modal,
  Platform,
  Pressable,
  SectionList,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Image,
} from "react-native";
import {
  black,
  black30,
  color_666666,
  color_F1F1F1,
  color_main,
  primary50,
  transparent,
  white,
} from "../../assets/style/colors";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useStore } from "../../store/UserStore";
import { useAppNavigation } from "../navigation";
import * as ImSdk from "../../../imsdk/api";
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { MessageMaskType, MessageType } from "../../constants/types";
import {
  applyLocalReadToTopicSummaryInList,
  clearUnreadIfCurrentTopic,
  getUserName,
  showSystemMsg,
} from "./chat-helper";
import cache from "../../cache";
import { LeftView } from "./CListItem";
import {
  getAvatarByItem2,
  getDisplayName,
  getMsgContent,
  isGroupTopic,
} from "../../utils/utils";
import { beforeDate } from "../../utils/date";
import { Badge } from "../../components/Badge";
import { SwipeableItem, SwipeableItemRef } from "../../components/SwipableItem";
import ReactNativeHapticFeedback from "react-native-haptic-feedback";
import { Msg } from "../../../imsdk/db/t_msg";
import {
  Str_AddFriends,
  Str_Chat,
  Str_CreateGroupChat,
  Str_Draft,
  Str_GoOpen,
  Str_GroupChat,
  Str_MessageForYou,
  Str_NoticeOpenTip,
  Str_Scan,
  Str_Search,
  Str_WithdrawAMsg,
} from "../../language/string_res";
import {
  ImageStyle,
  TextStyle,
} from "react-native/Libraries/StyleSheet/StyleSheetTypes";
import { useTranslation } from "react-i18next";
import { MQEventCallBack } from "../../../imsdk/api/mq";
import Sound from "react-native-sound";
import { TopicSummaryStat } from "../../store/utils";
import {
  getGroupDetail,
  GetJoinGroupList,
  processGroupData,
  useChatStateRefOnly,
  useChatStore,
} from "../../store/ChatStore";
import { User, defaultUser } from "../../../imsdk/db/t_user";
import { GroupMember } from "../../../imsdk/db/t_group_member";
import { RefreshControl } from "react-native-gesture-handler";
import SkeletonPlaceholder from "react-native-skeleton-placeholder";
import SearchIcon from "../../assets/svg/icon_search.svg";
import BaseScreen from "../BaseScreen";
import { getUid } from "../../store/token";
import globalEventBus from "../../utils/EventBus";
import { UserSchema } from "../../realm/contactSchema";
import { AddMenu } from "./components/AddMenu";

const ListItem = ({
  item,
  index,
  handleNavigation,
  isSelected,
}: {
  item: TopicWithSummary;
  index: number;
  handleNavigation: (item: TopicWithSummary) => void;
  isSelected: boolean;
}) => {
  function BadgeView() {
    if (item.topic.mute) {
      if (
        (item.summary &&
          item.summary.unreadCnt &&
          item.summary.unreadCnt > 0) ||
        item.hasApply === true
      ) {
        return (
          <View
            style={{
              position: "absolute",
              top: 10,
              start: 60,
              width: 8,
              height: 8,
              borderRadius: 10,
              backgroundColor: "red",
            }}
          />
        );
      } else {
        return null;
      }
    } else {
      const unreadCnt = item.summary?.unreadCnt;
      if (item.summary && unreadCnt && unreadCnt > 0) {
        return (
          <Badge
            style={{
              position: "absolute",
              top: 10,
              start: 55,
            }}
            visible={true}
            children={unreadCnt >= 99 ? "99+" : unreadCnt}
          />
        );
      } else {
        if (item.hasApply === true) {
          return (
            <View
              style={{
                position: "absolute",
                top: 10,
                start: 60,
                width: 8,
                height: 8,
                borderRadius: 10,
                backgroundColor: "red",
              }}
            />
          );
        }
        return null;
      }
    }
  }
  function getName() {
    const isGroup = isGroupTopic(item.topic.tid);
    if (!isGroup) {
      const user = item.users?.find((user) => user.uid !== getUid());
      if (user) {
        return getDisplayName(user);
      }
    }
    return (
      item.topic.remark || item.topic.name || (isGroup ? Str_GroupChat : "")
    );
  }
  return (
    <Pressable
      onPress={() => handleNavigation(item)}
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 13,
        backgroundColor: isSelected
          ? "#E8F5E9"
          : item.topic.order > 0
            ? primary50
            : white,
        paddingHorizontal: 16,
      }}
    >
      <LeftView left={getAvatarByItem2(item)} size={50} isRounded={true} isGroup={item.topic.type === "group"} />
      <BadgeView />
      <View style={{ flex: 1 }}>
        <Text
          numberOfLines={1}
          ellipsizeMode={"tail"}
          style={{
            color: black,
            fontSize: 16,
            fontFamily: "",
            fontWeight: "500",
            textAlign: "left",
          }}
        >
          {getName()}
        </Text>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <ContentText topic={item} />
          {item.topic.mute ? (
            <Image
              source={require("../../assets/image/icon_mute.png")}
              style={{ marginStart: 8, width: 12, height: 12 }}
            />
          ) : null}
        </View>
      </View>

      <Text style={{ fontSize: 14, color: black30 }}>
        {beforeDate(item.summary?.latestVisibleMsg?.stime)}
      </Text>
    </Pressable>
  );
};

export const ContentText = ({ topic }: { topic: TopicWithSummary }) => {
  const latestMessage = topic.summary?.latestVisibleMsg;
  const [systemTip, setSystemTip] = useState(
    latestMessage?.meta?.systemTip || ""
  );
  const [senderInfo, setSenderInfo] = useState<string>("");
  const im = ImSdk.getInstance();
  const { dispatch } = useStore();
  useEffect(() => {
    if (latestMessage && latestMessage.type === MessageType.SYSTEM) {
      showSystemMsg(JSON.parse(latestMessage.content), topic.users).then(
        (val: any) => {
          if (val !== systemTip) {
            setSystemTip(val);
            im.updateMsgMeta(latestMessage.mid, { systemTip: val });
          }
        }
      );
    }

    if (latestMessage) {
      if (
        latestMessage.sender !== im.CurrentUid() &&
        latestMessage.type !== MessageType.SYSTEM
      ) {
        if (topic.topic.type === "group") {
          let user;
          if (topic.users && topic.users.length > 0) {
            const index = topic.users.findIndex(
              (v) => v.uid === latestMessage.sender
            );
            if (index != -1) {
              user = topic.users[index];
            }
          }
          if (user) {
            setSenderInfo(getUserName(user) + ": ");
          } else {
            im.GetTopicDetail(topic.topic.tid).then((res) => {
              if (res.topic && res.topic.users) {
                const users = res.topic.users;
                const index = users.findIndex(
                  (v) => v.uid === latestMessage.sender
                );
                if (index != -1) {
                  topic.users = users;
                  setSenderInfo(getUserName(users[index]) + ": ");
                  dispatch({
                    type: "UPDATE_TOPIC_SUMMARY",
                    payload: [clearUnreadIfCurrentTopic(res.topic)],
                  });
                }
              }
            });
          }
        } else {
          //单聊不显示 名字
          // im.GetUser(latestMessage.sender).then((res) => {
          //     if (res.user) {
          //         setSenderInfo(getUserName(res.user) + ": ");
          //     }
          // });
        }
      } else if (senderInfo !== "") {
        setSenderInfo("");
      }
    }
  }, [latestMessage, topic.users]);
  const style: TextStyle = {
    color: black30,
    fontSize: 14,
    fontWeight: "400",
    fontFamily: "",
  };

  if (topic.topic.draft && topic.topic.draft.length > 0) {
    return (
      <Text style={style} numberOfLines={1} ellipsizeMode={"tail"}>
        {Str_Draft}:[{topic.topic.draft}]
      </Text>
    );
  }
  if (!latestMessage) {
    return <Text />;
  }
  if (latestMessage.mask === MessageMaskType.RECALL) {
    return (
      <Text numberOfLines={1} ellipsizeMode={"tail"} style={style}>
        {" "}
        {`${senderInfo}${Str_WithdrawAMsg}`}
      </Text>
    );
  }

  if (
    latestMessage.type === MessageType.VOICE ||
    latestMessage.type === MessageType.VIDEO ||
    latestMessage.type === MessageType.IMAGE ||
    latestMessage.type === MessageType.RTC_VOICE ||
    latestMessage.type === MessageType.RTC_VIDEO ||
    latestMessage.type === MessageType.DOCUMENT ||
    latestMessage.type === MessageType.TALK
  ) {
    const content = getMsgContent(latestMessage.type, "");
    return (
      <Text numberOfLines={1} ellipsizeMode={"tail"} style={style}>
        {senderInfo}
        {content}
      </Text>
    );
  }

  if (latestMessage.type === MessageType.SYSTEM) {
    return (
      <Text style={style} numberOfLines={1} ellipsizeMode={"tail"}>
        {systemTip}
      </Text>
    );
  }

  if (topic.summary?.latestAt) {
    return (
      <Text
        numberOfLines={1}
        ellipsizeMode={"tail"}
        style={[style, { color: "red" }]}
      >
        {`[${Str_MessageForYou}]`}
        <Text style={style}>
          {senderInfo}
          {latestMessage.content.trimStart()}
        </Text>
      </Text>
    );
  }

  return (
    <Text style={style} numberOfLines={1} ellipsizeMode={"tail"}>
      {senderInfo}
      {latestMessage.content?.trimStart()}
    </Text>
  );
};

export function topic_basic_filter(item: TopicWithSummary): boolean {
  return !(
    item.topic.hidemid !== "" &&
    item.topic.hidemid >= (item.summary?.latest?.mid ?? "")
  );
}

Sound.setCategory("Playback", true);
let mp3 = require("../../assets/sounds/sound.wav"); //支持众多格式

// Web-safe Sound wrapper
let sound: any;
try {
  sound = new Sound(mp3);
} catch (err) {
  // On web, Sound might not be available, provide fallback
  console.warn("Sound initialization failed, using web fallback:", err);
  sound = {
    play: (callback?: (success: boolean) => void) => {
      // Try to play audio using HTMLAudioElement on web
      if (Platform.OS === "web" && typeof window !== "undefined") {
        try {
          const audio = new Audio(mp3);
          audio.play().catch(e => console.warn("Audio play failed:", e));
          if (callback) {
            setTimeout(() => callback(true), 100);
          }
        } catch (e) {
          console.warn("Web audio fallback failed:", e);
          if (callback) callback(false);
        }
      }
    },
  };
}

export const CurTid = {
  tid: "",
};

// 防止重复播放音频
let lastSoundPlayTime = 0;
const SOUND_PLAY_DEBOUNCE = 500; // 500ms 内不重复播放

export function openNotify(data: Msg, topic?: TopicSummaryStat) {
  setTimeout(() => {
    const tid = CurTid.tid; //chatState.curTopicWithSummary.topic.tid;
    const index1 = topic?.top.findIndex((v) => data.tid === v.topic.tid) ?? -1;
    const index2 =
      topic?.normal.findIndex((v) => data.tid === v.topic.tid) ?? -1;

    if (index1 < 0 && index2 < 0) {
      return;
    }
    if (index1 >= 0) {
      const unreadCnt = topic?.top[index1].summary?.unreadCnt || 0;
      if (unreadCnt <= 0) {
        return;
      }
    }
    if (index2 >= 0) {
      const unreadCnt = topic?.normal[index2].summary?.unreadCnt || 0;
      if (unreadCnt <= 0) {
        return;
      }
    }
    if (data.sender === ImSdk.getInstance().CurrentUid()) {
      return;
    }
    if (data.visible === 1 || data.tid === tid) {
      return;
    }

    ImSdk.getInstance()
      .GetTopicDetail(data.tid, true)
      .then((res) => {
        if (res.topic && res.topic.topic.mute) {
          return;
        }

        // 防止音频重复播放
        const now = Date.now();
        if (now - lastSoundPlayTime < SOUND_PLAY_DEBOUNCE) {
          console.warn("Sound play debounced - too frequent:", now - lastSoundPlayTime, "ms");
          return;
        }
        lastSoundPlayTime = now;

        sound.play();
        const options = {
          enableVibrateFallback: true,
          ignoreAndroidSystemSettings: false,
        };
        // Only trigger native haptic feedback on supported platforms (iOS/Android).
        // On web, use Vibration API as fallback.
        if (Platform.OS !== "web") {
          try {
            ReactNativeHapticFeedback.trigger("impactHeavy", options);
          } catch (err) {
            console.warn("Haptic feedback trigger failed:", err);
          }
        } else if (typeof navigator !== "undefined" && navigator.vibrate) {
          // Use browser Vibration API on web (if supported)
          navigator.vibrate(50);
        }
      });
  }, 300);
}

const ChatScreen = ({ selectedTid }: { selectedTid?: string | null }) => {
  const { state, dispatch } = useStore();
  const navigation = useAppNavigation();
  const [totalUnAt, setTotalUnAt] = useState(0);
  const [totalUnread, setTotalUnread] = useState(0);
  const im = ImSdk.getInstance();
  const groupApply = useRef<string[]>([]);
  const { chatState, chatDispatch } = useChatStore();
  const chatStateRef = useChatStateRefOnly();
  const [groupApplyVersion, setGroupApplyVersion] = useState<number>(0);
  const [refreshing, setRefreshing] = useState(false);
  // 初始化时检查是否已有数据，有数据就不显示 loading
  const [isLoading, setIsLoading] = useState(() => {
    const hasData =
      state?.topicSummaryList &&
      (state.topicSummaryList.top.length > 0 ||
        state.topicSummaryList.normal.length > 0);
    return !hasData;
  });

  useTranslation(); //防止切换语言的时候页面不更新

  // 监听滚动到指定会话的事件
  useEffect(() => {
    const handleScrollToTopic = (data: { tid: string }) => {
      // 延迟执行，确保viewList已经更新
      setTimeout(() => {
        if (!sectionList.current) {
          return;
        }
        // 直接使用state来查找对应的会话
        const filter = (item: TopicWithSummary): boolean => {
          return topic_basic_filter(item);
        };
        const top = state?.topicSummaryList?.top?.filter(filter) || [];
        const normal = state?.topicSummaryList?.normal?.filter(filter) || [];
        const allSections = [
          { title: "top", data: top },
          { title: "normal", data: normal },
        ];

        // 查找对应的会话
        for (
          let sectionIndex = 0;
          sectionIndex < allSections.length;
          sectionIndex++
        ) {
          const section = allSections[sectionIndex];
          const itemIndex = section.data.findIndex(
            (item) => item.topic.tid === data.tid
          );
          if (itemIndex !== -1) {
            // 滚动到对应的会话
            setTimeout(() => {
              sectionList.current?.scrollToLocation({
                sectionIndex,
                itemIndex,
                viewOffset: 0,
                viewPosition: 0.5, // 滚动到中间位置
              });
            }, 100);
            break;
          }
        }
      }, 500); // 增加延迟，确保数据已更新
    };

    globalEventBus.on("ScrollToTopic", handleScrollToTopic);

    const handleShowContactInfo = (user: User | UserSchema) => {
      // 确保user是User类型
      const contactUser: User = {
        ...defaultUser,
        ...user,
        name: user.name || "",
        nick: user.nick || "",
        avatar: user.avatar || "",
        appkey: user.appkey || "",
      };
      navigation.navigate("ContactInfo", { current: contactUser });
    };
    globalEventBus.on("ShowContactInfo", handleShowContactInfo);

    return () => {
      globalEventBus.off("ScrollToTopic", handleScrollToTopic);
      globalEventBus.off("ShowContactInfo", handleShowContactInfo);
    };
  }, [state?.topicSummaryList, state?.dataVersion]);

  function refreshTopic() {
    setRefreshing(true);
    im.GetAllTopicListRemote().then(() => {
      setRefreshing(false);
    });
  }

  const viewList = useMemo(() => {
    const filter = (item: TopicWithSummary): boolean => {
      return topic_basic_filter(item);
    };
    const top = state?.topicSummaryList?.top?.filter(filter) || [];
    const normal = state?.topicSummaryList?.normal?.filter(filter) || [];
    if (!im.CurrentAppkey().startsWith("P")) {
      return [
        { title: "top", data: top || [] },
        { title: "normal", data: normal || [] },
      ];
    }

    const boxTop: TopicWithSummary[] = [];
    top?.forEach((v) => {
      const quit = v.summary?.isQuit ?? false;
      const hasApply = groupApply.current.includes(v.topic.tid);
      if (!quit) {
        boxTop.push({ ...v, hasApply });
      } else {
        //如果是不在群内则删除
        im.DelTopic(v.topic.tid).then();
      }
    });

    const boxNormal: TopicWithSummary[] = [];
    normal?.forEach((v) => {
      const quit = v.summary?.isQuit ?? false;
      const hasApply = groupApply.current.includes(v.topic.tid);
      if (!quit) {
        boxNormal.push({ ...v, hasApply });
      } else {
        //如果是不在群内则删除
        im.DelTopic(v.topic.tid).then();
      }
    });

    return [
      { title: "top", data: boxTop || [] },
      { title: "normal", data: boxNormal || [] },
    ];
  }, [state?.dataVersion, state?.topicSummaryList, groupApplyVersion]);

  // 追踪 viewList 变化
  useEffect(() => {
    // viewList 已更新
  }, [viewList]);

  useEffect(() => {
    const justSwitched = cache.Get("justSwitchedAccount") === true;

    if (justSwitched) {
      setIsLoading(false);
      cache.Delete("justSwitchedAccount");
      return;
    }

    // 检查是否已经有数据，如果有则直接显示
    if (
      state?.topicSummaryList &&
      (state.topicSummaryList.top.length > 0 ||
        state.topicSummaryList.normal.length > 0)
    ) {
      console.log("✅ [ChatScreen] 已有会话数据，直接显示");
      setIsLoading(false);
      return;
    }

    const handleReady = () => {
      console.log("✅ [ChatScreen] 收到 topic_list_ready 事件");
      setIsLoading(false);
    };

    const sub = DeviceEventEmitter.addListener("topic_list_ready", handleReady);

    return () => {
      sub.remove(); // 清理监听
    };
  }, [state?.topicSummaryList]);

  useEffect(() => {
    const topicCallback: MQEventCallBack = async (res) => {
      if (res.type === "group_apply") {
        const tid = res.data.group_apply?.tid || "";
        if (!groupApply.current.includes(tid)) {
          groupApply.current = [...groupApply.current, tid];
          setGroupApplyVersion(groupApplyVersion + 1);
        }
      }
    };
    im.on("group_apply", topicCallback);
    return () => {
      im.off("group_apply", topicCallback);
    };
  }, []);

  useEffect(() => {
    // 计算会话数量
    let atCnt = 0;
    let unreadTopicCnt = 0;
    let unreadTotal = 0;
    const calc = (topics: TopicWithSummary[]) => {
      const n = topics.length;
      for (let i = 0; i < n; i++) {
        if (topics[i].summary?.isQuit === true) {

          continue;
        }
        if ((topics[i].summary?.unreadCnt || 0) > 0) {
          unreadTopicCnt++;
          if (!topics[i].topic.mute) {
            unreadTotal += topics[i].summary?.unreadCnt || 0;
          }
          const at = topics[i].summary?.latestAt?.mid || "";
          if (at !== "" && topics[i].topic.lsMid <= at) {
            atCnt++;
          }
        }
      }
    };
    const { top, normal } = state?.topicSummaryList ?? { top: [], normal: [] };
    calc(top);
    calc(normal);
    const total = top.length + normal.length;
    console.info(
      "总共会话数:",
      total,
      "被AT:",
      atCnt,
      "未读会话:",
      unreadTopicCnt,
      "未读消息:",
      unreadTotal
    );

    cache.Set<number>("unreadTotal", unreadTotal);
    if (totalUnAt !== atCnt) {
      setTotalUnAt(atCnt);
    }
    if (totalUnread !== unreadTotal) {
      // push.RefreshBadge();
      setTotalUnread(unreadTotal);
      DeviceEventEmitter.emit("unreadTotal", unreadTotal);
    }
  }, [state?.dataVersion, state?.topicSummaryList]);

  const lastSection = useRef<{ sectionIndex: number; itemIndex: number }>({
    sectionIndex: 0,
    itemIndex: 0,
  });
  const sectionList = useRef<SectionList>(null);

  useEffect(() => {
    const msg_tab_double_click = () => {
      if (
        !(sectionList && sectionList.current && viewList && viewList.length > 0)
      ) {
        return;
      }
      let { itemIndex, sectionIndex } = lastSection.current;
      let findItem = 0;
      let findSection = 0;
      let times = 0;
      const find_unread = (s: number, i: number) => {
        while (true) {
          console.log("times:", ++times);
          for (let x = i; x < viewList[s].data.length; x++) {
            if (s === sectionIndex && x === itemIndex) {
              findSection = s;
              findItem = x;
              return;
            }
            if (viewList[s].data[x].summary?.unreadCnt) {
              findSection = s;
              findItem = x;
              return;
            }
          }
          s = ++s % viewList.length;
          i = 0;
        }
      };
      find_unread(sectionIndex, itemIndex + 1);
      console.log("指定会话到", findSection, findItem);
      lastSection.current = {
        sectionIndex: findSection,
        itemIndex: findItem,
      };
      sectionList &&
        sectionList.current &&
        sectionList.current.scrollToLocation({
          sectionIndex: findSection,
          itemIndex: findItem,
          animated: true,
        });
    };

    DeviceEventEmitter.addListener(
      "msg_tab_double_click",
      msg_tab_double_click
    );
    return () => {
      // DeviceEventEmitter.removeListener(
      //   'msg_tab_double_click',
      //   msg_tab_double_click,
      // );
    };
  }, [viewList, sectionList]);

  const toChatCallback = (tid: string) => {
    groupApply.current = groupApply.current.filter((v) => v !== tid);
    setGroupApplyVersion((pre) => pre + 1);
  };

  const ChatSkeleton = () => {
    return (
      <SkeletonPlaceholder
        borderRadius={4}
        backgroundColor="#E1E9EE"
        highlightColor="#F2F8FC"
      >
        <View>
          {[...Array(6)].map((_, idx) => (
            <View key={idx} style={{ flexDirection: "row", padding: 16 }}>
              <View style={{ width: 50, height: 50, borderRadius: 25 }} />
              <View style={{ marginLeft: 12, flex: 1 }}>
                <View style={{ width: "50%", height: 14, marginBottom: 6 }} />
                <View style={{ width: "80%", height: 14 }} />
              </View>
            </View>
          ))}
        </View>
      </SkeletonPlaceholder>
    );
  };

  function handleNavigation(item: TopicWithSummary) {
    if (item.topic.type === "box") {
      return;
    }
    const tid = item.topic.tid;
    CurTid.tid = tid;
    let next: TopicWithSummary;
    if (!isGroupTopic(tid)) {
      const users = [...(item.users || [])];
      if (state?.user && !users.map((v) => v.uid).includes(state.user.uid)) {
        users.push(state.user as User);
      }
      next = { ...item, users };
    } else {
      next = { ...item };
    }
    const cleared = applyLocalReadToTopicSummaryInList(next);
    dispatch({ type: "UPSERT_TOPIC_SUMMARY", payload: [cleared] });
    chatDispatch({ type: "CHAT_SWITCH_TOPIC", payload: cleared });
    const titleName =
      Platform.OS === "web"
        ? getAvatarByItem2(cleared).name
        : cleared.topic.remark || cleared.topic.name || Str_GroupChat;

    if (Platform.OS === "web") {
      globalEventBus.emit("ShowWebDetail", {
        screenName: "ChatList",
        params: { topic: cleared, titleName },
      });
    } else {
      navigation.navigate("ChatList", { titleName });
    }

    toChatCallback(tid);
    setTimeout(() => {
      if (isGroupTopic(tid)) {
        processGroupData(
          { group: cleared.group, members: (cleared.users || []) as GroupMember[] },
          chatDispatch,
        );
      } else if (!cleared.users?.length) {
        getGroupDetail(tid, chatDispatch);
      }
      GetJoinGroupList(chatStateRef.current, chatDispatch, tid);
    }, 0);
  }

  const HeaderComponent = () => (
    <View style={styles.searchContainer} key="ScreenChatHeader">
      <Pressable
        onPress={() => navigation.navigate("ChatSearch")}
        style={[styles.search, { flex: 1 }]}
      >
        <SearchIcon width={20} height={20} />
        <Text style={styles.searchText}>{Str_Search}</Text>
      </Pressable>
      <AddMenu />
    </View>
  )

  return (
    <BaseScreen>
      <View style={styles.container}>
        <View style={styles.contentContainer}>
          <HeaderComponent />
          <View style={styles.listContainer}>
            {isLoading ? (
              <ChatSkeleton />
            ) : (
              <SectionList
                ref={sectionList}
                keyExtractor={(item: TopicWithSummary) => item.topic.tid}
                sections={viewList}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={false}
                style={{ backgroundColor: white }}
                contentContainerStyle={{ backgroundColor: white }}
                refreshControl={
                  <RefreshControl
                    refreshing={refreshing}
                    onRefresh={refreshTopic}
                  />
                }
                ListEmptyComponent={() => {
                  return (
                    <View style={{ padding: 20, alignItems: "center" }}>
                      <Text style={{ color: color_666666 }}>暂无会话</Text>
                    </View>
                  );
                }}
                renderItem={({ item, index }) => {
                  const isSelected = selectedTid === item.topic.tid;
                  return (
                    <SwipeableItem
                      topicSummary={item}>
                      <ListItem
                        item={item}
                        index={index}
                        handleNavigation={handleNavigation}
                        isSelected={isSelected}
                      />
                    </SwipeableItem>
                  );
                }}
              />
            )}
          </View>
        </View>
      </View>
    </BaseScreen>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#FFFFFF",
  },
  contentContainer: {
    flex: 1,
    flexDirection: "column",
  },
  listContainer: {
    flex: 1,
    backgroundColor: "white",
    marginTop: 20,
    borderTopStartRadius: 17,
    borderTopEndRadius: 17,
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    marginTop: 16,
    marginBottom: 12,
  },
  search: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    height: 48,
    borderRadius: 24,
    marginRight: 12,
    backgroundColor: color_F1F1F1,
    paddingHorizontal: 16,
    flex: 1,
  },
  searchText: {
    fontSize: 15,
    color: color_666666,
    marginStart: 10,
    textAlignVertical: "center",
    flex: 1,
  },
  annContainer: {
    overflow: "visible",
    paddingHorizontal: 12,
    marginHorizontal: 12,
    marginTop: 14,
    alignItems: "center",
    flexDirection: "row",
  },
  annBg: {
    borderRadius: 13,
    position: "absolute",
    top: 0,
    start: 0,
    bottom: 0,
    end: 0,
  },
  announcement: { fontSize: 12, color: color_main, textAlign: "center" },
  annBtnContainer: {
    backgroundColor: color_main,
    height: 24,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 22,
  },
  annBtn: {
    color: "white",
    paddingHorizontal: 9,
    fontSize: 12,
    textAlign: "center",
    textAlignVertical: "center",
    fontFamily: "lucida grande",
    fontWeight: "bold",
  },
});
export default ChatScreen;
